import React, { useState } from 'react';
import './AboutTab.css';
import supabase from "../../../supabaseClient";

const LANGUAGE_OPTIONS = [
  'English', 'Spanish', 'French', 'German', 'Chinese', 'Japanese', 'Other'
];

const AboutTab = ({ event, creatorProfile, userProfile, userAttendanceStatus, onAttendanceChange, onEventUpdated }) => {
  const isAdmin = userProfile && event && userProfile.id === event.created_by;
  const [editMode, setEditMode] = useState(false);
  const [form, setForm] = useState({
    title: event?.title || '',
    description: event?.description || '',
    date: event?.date || '',
    time: event?.time || '',
    language: event?.language || '',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    try {
      const { error } = await supabase
        .from('events')
        .update({
          title: form.title,
          description: form.description,
          date: form.date,
          time: form.time,
          language: form.language
        })
        .eq('id', event.id);
      if (error) throw error;
      setEditMode(false);
      if (onEventUpdated) onEventUpdated();
    } catch (err) {
      setError(err.message || 'Failed to update event.');
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    setEditMode(false);
    setForm({
      title: event?.title || '',
      description: event?.description || '',
      date: event?.date || '',
      time: event?.time || '',
      language: event?.language || '',
    });
    setError(null);
  };

  return (
    <div className="event-about-tab modern-event-about-tab">
      <div className="event-about-header">
        <h2>About This Event</h2>
        {isAdmin && !editMode && (
          <button className="edit-event-btn" onClick={() => setEditMode(true)}>
            Edit
          </button>
        )}
      </div>
      {editMode ? (
        <div className="event-about-edit-form">
          <div className="event-about-section">
            <label>Title</label>
            <input name="title" value={form.title} onChange={handleChange} required />
          </div>
          <div className="event-about-section">
            <label>Description</label>
            <textarea name="description" value={form.description} onChange={handleChange} rows={3} required />
          </div>
          <div className="event-about-section">
            <label>Date</label>
            <input type="date" name="date" value={form.date} onChange={handleChange} required />
          </div>
          <div className="event-about-section">
            <label>Time</label>
            <input type="time" name="time" value={form.time} onChange={handleChange} required />
          </div>
          <div className="event-about-section">
            <label>Language</label>
            <select name="language" value={form.language} onChange={handleChange} required>
              <option value="">Select Language</option>
              {LANGUAGE_OPTIONS.map(lang => (
                <option key={lang} value={lang}>{lang}</option>
              ))}
            </select>
          </div>
          {error && <div className="event-about-error">{error}</div>}
          <div className="event-about-edit-actions">
            <button onClick={handleSave} disabled={saving}>{saving ? 'Saving...' : 'Save'}</button>
            <button onClick={handleCancel} className="cancel-btn" disabled={saving}>Cancel</button>
          </div>
        </div>
      ) : (
        <>
          <div className="event-about-info-grid">
            <div className="event-about-section event-about-description-section">
              <strong>Description:</strong>
              <span className="event-about-description">{event?.description || 'No description provided.'}</span>
            </div>
            <div className="event-about-section"><strong>Date:</strong> <span>{event?.date}</span></div>
            <div className="event-about-section"><strong>Time:</strong> <span>{event?.time}</span></div>
            <div className="event-about-section"><strong>Language:</strong> <span>{event?.language}</span></div>
            {creatorProfile && (
              <div className="event-about-section"><strong>Created by:</strong> <span>{creatorProfile.display_name || creatorProfile.name || creatorProfile.email}</span></div>
            )}
          </div>

          {/* CTA for non-attendees: encourage them to join the event */}
          {!userAttendanceStatus && onAttendanceChange && (
            <div className="event-about-cta">
              <h3>Interested in this event?</h3>
              <p>Mark yourself as going or interested to unlock the forum, media, files, and participant details.</p>
              <div className="event-about-cta-actions">
                <button
                  type="button"
                  className="event-about-cta-btn primary"
                  onClick={() => onAttendanceChange('going')}
                >
                  I'm going
                </button>
                <button
                  type="button"
                  className="event-about-cta-btn secondary"
                  onClick={() => onAttendanceChange('interested')}
                >
                  I'm interested
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default AboutTab;